import { render } from "./PauseVideo.vue?vue&type=template&id=74182365&scoped=true"
import script from "./PauseVideo.vue?vue&type=script&lang=js"
export * from "./PauseVideo.vue?vue&type=script&lang=js"

import "./PauseVideo.vue?vue&type=style&index=0&id=74182365&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74182365"]])

export default __exports__